import LOGO from "./izunefesh_logo.svg";
import GUIDE_NOT_FOUND from "./guide_not_found.svg";
import DOCTORS_NOT_FOUND from "./doctor_not_found.svg";
import ERROR_NOT_FOUND from "./error_not_found.svg";

export const ICONS = {
  LOGO,
  GUIDE_NOT_FOUND,
  DOCTORS_NOT_FOUND,
  ERROR_NOT_FOUND,
};
